export const getActivityId = (
  initialActivityId: number | null | undefined,
  selectedEngagementId: number | undefined
): number | undefined => {
  if (initialActivityId && selectedEngagementId && initialActivityId !== selectedEngagementId) {
    return selectedEngagementId;
  }
  return initialActivityId ?? selectedEngagementId;
};
